var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLgiAquaplaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lgi_x5F_aquaplaning",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "68px",
    viewBox: "0 0 48 68",
    style: {
      enableBackground: "new 0 0 48 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.176;stroke-miterlimit:2.613;}\n\t.st2{fill:#B33229;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.3,46H8.7c-1.3,0-2.3,1.1-2.3,2.3V63c0,1.3,1.1,2.4,2.3,2.4h30.6c1.3,0,2.3-1.1,2.3-2.4V48.3 C41.6,47.1,40.6,46,39.3,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3,46.6H8.7c-1,0-1.8,0.8-1.8,1.8V63c0,1,0.8,1.8,1.8,1.8h30.6c1,0,1.8-0.8,1.8-1.8V48.3C41,47.4,40.3,46.6,39.3,46.6z  M40.2,63c0,0.5-0.4,0.9-0.9,0.9H8.7c-0.5,0-0.9-0.4-0.9-0.9V48.3c0-0.5,0.4-0.9,0.9-0.9h30.6c0.5,0,0.9,0.4,0.9,0.9V63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,65.4c-1.3,0-2.3-1.1-2.3-2.4V48.3C6.4,47,7.5,46,8.7,46h30.6c1.3,0,2.3,1.1,2.3,2.3V63 c0,1.3-1.1,2.4-2.3,2.4H8.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,4.5c-1.1,0-2.1,0.6-2.6,1.5L2.8,38.5c-0.5,0.9-0.5,2.1,0,3C3.4,42.4,4.4,43,5.4,43h37.1 c1.1,0,2.1-0.6,2.6-1.5s0.5-2.1,0-3L26.6,6C26.1,5.1,25.1,4.5,24,4.5L24,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,9.5L40.8,39H7.2L24,9.5 M24,5.5c-0.7,0-1.4,0.3-1.7,1L3.7,39c-0.8,1.3,0.2,3,1.7,3h37.1 c1.5,0,2.5-1.7,1.7-3L25.7,6.5C25.4,5.9,24.7,5.5,24,5.5L24,5.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.2,56.8h2v1.8c0,0.4-0.3,0.8-0.8,0.8H29c-0.4,0-0.8-0.3-0.8-0.8V56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,56.8h2v1.8c0,0.4-0.3,0.8-0.8,0.8h-0.5c-0.4,0-0.8-0.3-0.8-0.8L18,56.8L18,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,52.1c-0.3-0.6-0.8-2-1.1-2.6c-0.3-0.6-0.7-0.6-1-0.6h-7.8c-0.4,0-0.8,0.1-1.1,0.6c-0.3,0.6-0.9,2.1-1.1,2.6 c-0.1,0.3-0.3,0.7-0.5,0.9c-0.1,0.2-0.2,0.4-0.2,0.6v2.3c0,0.3,0.4,0.8,0.8,0.8h12c0.3,0,0.8-0.4,0.8-0.8v-2.3 c0-0.2-0.1-0.4-0.2-0.6C30.4,52.8,30.2,52.4,30.1,52.1z M19.8,49.8c0.1-0.2,0.2-0.3,0.4-0.3h7.7c0.2,0,0.3,0.1,0.4,0.3l1.1,2.7 H18.7L19.8,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,59.7c-0.2-0.1-0.5-0.1-0.9-0.1c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3c-0.6,0-0.8-0.1-1.1-0.3 c-0.3-0.2-0.7-0.3-1.4-0.3c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3s-0.8-0.1-1.1-0.3c-0.3-0.2-0.7-0.3-1.4-0.3 c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3c-0.6,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.7-0.3-1.4-0.3c-0.5,0-0.8,0.1-1,0.2v0.7 c0.3-0.1,0.5-0.2,1-0.2c0.6,0,0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3 c0.6,0,0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3s0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3 c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3c0.4,0,0.6,0.1,0.9,0.2V59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,61.2c-0.2-0.1-0.5-0.1-0.9-0.1c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3c-0.6,0-0.8-0.1-1.1-0.3 c-0.3-0.2-0.7-0.3-1.4-0.3c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3s-0.8-0.1-1.1-0.3c-0.3-0.2-0.7-0.3-1.4-0.3 c-0.7,0-1.1,0.2-1.4,0.3s-0.6,0.3-1.1,0.3c-0.6,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.7-0.3-1.4-0.3c-0.5,0-0.8,0.1-1,0.2V62 c0.3-0.1,0.5-0.2,1-0.2c0.6,0,0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3 c0.6,0,0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3s0.8,0.1,1.1,0.3c0.3,0.2,0.7,0.3,1.4,0.3 c0.7,0,1.1-0.2,1.4-0.3s0.6-0.3,1.1-0.3c0.4,0,0.6,0.1,0.9,0.2V61.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 33,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25,31 23,31 22,17 26,17  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLgiAquaplaning);
export default __webpack_public_path__ + "static/media/icon-lgi_aquaplaning.dc8f688a450f40ac1e8617d7d11d03f6.svg";
export { ForwardRef as ReactComponent };